import React from "react";

import styles from "./Section2.module.scss";

export const Section4 = function () {
  return (
    <section id="info-gs" className={`${styles.section2Wrapper} cc--component-container`}>
      <div className={styles.section2Container}>
        <div className={styles.section2Content}>
          <h3>Keep Up With a Changing Industry</h3>
          <p>
            New advances in technologies like artificial intelligence and machine learning have captured the world’s
            attention. But, as the technology evolves, so do the cybersecurity risks businesses across every industry
            face.
          </p>
          <p>
            Learn how to protect the integrity, security, and confidentiality of your digital assets as we navigate the
            Fourth Industrial Revolution.
          </p>
        </div>
      </div>
    </section>
  );
};
